import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import API_BASE_URL from '../config/api';
import './ClientLogin.css';

class VerifyCode extends Component {
  state = {
    code: '',
    errorMessage: '',
    loading: false,
    redirectToLogin: false,
    infoMessage: '',
  };

  componentDidMount() {
    const token = localStorage.getItem('authToken');
    const username = localStorage.getItem('username');

    if (!token || !username) {
      this.setState({ redirectToLogin: true });
    }
  }

  handleChange = (e) => {
    this.setState({
      code: e.target.value,
      errorMessage: '',
      infoMessage: '',
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.state.loading) return;

    const token = localStorage.getItem('authToken');
    const username = localStorage.getItem('username');

    if (!token || !username) {
      this.setState({ redirectToLogin: true });
      return;
    }

    if (!this.state.code.trim()) {
      this.setState({ errorMessage: 'Please enter the verification code.' });
      return;
    }

    this.setState({ loading: true, errorMessage: '', infoMessage: '' });

    try {
      const response = await fetch(`${API_BASE_URL}/api/verify-code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          username,
          code: this.state.code.trim(),
        }),
      });

      const data = await response.json();

      if (response.ok && data.status === 'success') {
        localStorage.setItem('is2FAVerified', 'true');
        localStorage.setItem('role', data.role || localStorage.getItem('role') || 'guest');

        if (data.accessToken) {
          localStorage.setItem('authToken', data.accessToken);
        }

        window.location.replace('/dashboard');
        return;
      }

      this.setState({
        errorMessage: data.message || 'Invalid verification code.',
      });
    } catch (error) {
      console.error('Verification error:', error);
      this.setState({
        errorMessage: 'Server error. Please try again later.',
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleResendCode = async () => {
    if (this.state.loading) return;

    const token = localStorage.getItem('authToken');
    const username = localStorage.getItem('username');

    if (!token || !username) {
      this.setState({ redirectToLogin: true });
      return;
    }

    this.setState({ loading: true, errorMessage: '', infoMessage: '' });

    try {
      const response = await fetch(`${API_BASE_URL}/api/send-code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          username,
        }),
      });

      const data = await response.json();

      if (response.ok && data.status === 'success') {
        this.setState({
          infoMessage: 'A new verification code has been sent to your email.',
        });
      } else {
        this.setState({
          errorMessage: data.message || 'Failed to resend verification code.',
        });
      }
    } catch (error) {
      console.error('Resend code error:', error);
      this.setState({
        errorMessage: 'Server error. Please try again later.',
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    if (this.state.redirectToLogin) {
      return <Navigate to="/login" replace />;
    }

    return (
      <div className="login-page-wrap">
        <div className="login-card">
          <p className="login-label">2FA VERIFICATION</p>
          <h1>Enter Code</h1>

          <p className="login-subtext">
            We sent a 6-digit verification code to your registered email address.
          </p>

          <form onSubmit={this.handleSubmit} className="login-form">
            <input
              type="text"
              name="code"
              placeholder="Enter 6-digit code"
              value={this.state.code}
              onChange={this.handleChange}
              maxLength={6}
              autoFocus
            />

            {this.state.errorMessage && (
              <div className="login-error">{this.state.errorMessage}</div>
            )}

            {this.state.infoMessage && (
              <div className="login-info">{this.state.infoMessage}</div>
            )}

            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? 'Verifying...' : 'Verify'}
            </button>

            <button
              type="button"
              onClick={this.handleResendCode}
              disabled={this.state.loading}
              style={{ marginTop: '10px' }}
            >
              Resend Code
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default VerifyCode;
